/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnabledPayer
 */
export interface EnabledPayer {
    /**
     * 
     * @type {string}
     * @memberof EnabledPayer
     */
    payor_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EnabledPayer
     */
    inn_facility_ids?: Array<string>;
}

/**
 * Check if a given object implements the EnabledPayer interface.
 */
export function instanceOfEnabledPayer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "payor_id" in value;

    return isInstance;
}

export function EnabledPayerFromJSON(json: any): EnabledPayer {
    return EnabledPayerFromJSONTyped(json, false);
}

export function EnabledPayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnabledPayer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payor_id': json['payor_id'],
        'inn_facility_ids': !exists(json, 'inn_facility_ids') ? undefined : json['inn_facility_ids'],
    };
}

export function EnabledPayerToJSON(value?: EnabledPayer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payor_id': value.payor_id,
        'inn_facility_ids': value.inn_facility_ids,
    };
}

